import React, { useEffect, useState } from "react";
import { Tab, Tabs } from 'react-bootstrap';  
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import AdminDashboard from "./admindashboard";
import CompanyProfile from "./companyProfile";
import EmployeesDetails from "./EmployeesDetails";
import Designations from "./Designations";
import CompanyDoctorsDetails from "./companyDoctorsDetails";
import GeoLocations from "./geoLocations";
import CompanySettings from "./companySettings";
import LinkedLabs from "./linkedLabs";
import CompanyInvoicesTab from "./companyInvoicesTab";
import BookingCategories from "./bookingCategories";
import "./hm-theme.css";

function CompanyDetailsTab() {
  const { orgcode } = useParams();
  const [activeTab, setActiveTab] = useState('companyprofile');

  return (
    <div>
      <AdminDashboard />

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Main Tabs Container */}
          <div className="hm-card hm-tabs">
            <div className="hm-card-body p-4">
              <Tabs
                id="company-details-tabs"
                activeKey={activeTab}
                onSelect={(tab) => setActiveTab(tab)}
                className="mb-4"
              >
                <Tab
                  eventKey="companyprofile"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>domain</i>
                      Company Profile
                    </span>
                  }
                >
                  {activeTab === 'companyprofile' && (
                    <CompanyProfile selectedOrgcode={orgcode} />
                  )}
                </Tab>

                <Tab
                  eventKey="employees"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>groups</i>
                      Employees Details
                    </span>
                  }
                >
                  {activeTab === 'employees' && (
                    <EmployeesDetails selectedOrgcode={orgcode} />
                  )}
                </Tab>

                <Tab
                  eventKey="doctors"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>medical_services</i>
                      Doctors Details
                    </span>
                  }
                >
                  {activeTab === 'doctors' && (
                    <CompanyDoctorsDetails selectedOrgcode={orgcode} />
                  )}
                </Tab>

                <Tab
                  eventKey="designations"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>badge</i>
                      Designations and Packages
                    </span>
                  }
                >
                  {activeTab === "designations" && <Designations selectedOrgcode={orgcode}/>}
                </Tab>

                <Tab
                  eventKey="invoices"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>receipt_long</i>
                      Invoices
                    </span>
                  }
                >
                  {activeTab === "invoices" && <CompanyInvoicesTab selectedOrgcode={orgcode}/>}
                </Tab>

                <Tab
                  eventKey="locations"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>location_on</i>
                      Locations
                    </span>
                  }
                >
                  {activeTab === "locations" && <GeoLocations selectedOrgcode={orgcode}/>}
                </Tab>

                <Tab
                  eventKey="labsMapping"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>biotech</i>
                      Labs
                    </span>
                  }
                >
                  {activeTab === "labsMapping" && <LinkedLabs selectedOrgcode={orgcode}/>}
                </Tab>

                <Tab
                  eventKey="categories"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>category</i>
                      Categories
                    </span>
                  }
                >
                  {activeTab === "categories" && <BookingCategories selectedOrgcode={orgcode}/>}
                </Tab>

                <Tab
                  eventKey="settings"
                  title={
                    <span className="d-inline-flex align-items-center gap-1">
                      <i className="material-icons" style={{ fontSize: "1.1rem" }}>settings</i>
                      Settings
                    </span>
                  }
                >
                  {activeTab === "settings" && <CompanySettings selectedOrgcode={orgcode}/>}
                </Tab>
              </Tabs>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CompanyDetailsTab;